export function getLabelName (label) {
    return process.env[`VUE_APP_LABEL_${label}`] ? process.env[`VUE_APP_LABEL_${label}`] : label
}
